import { gql } from '@apollo/client';

export const CREATE_CUSTOMER = gql`
  mutation CreateCustomerForChatbot($input: CreateCustomerInput) {
    createCustomerForChatbot(input: $input) {
      _id
    }
  }
`;